export default __webpack_public_path__ + "static/media/Vazir-Medium.82c1133e.ttf";